var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddToHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 369,
    height: 263,
    viewBox: "0 0 369 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.487 17.4023C350.55 29.251 351.521 40.6261 352.535 51.988C352.727 54.2546 352.865 55.8538 353.596 58.6437C354.117 60.7217 355.32 65.1028 357.55 64.0312C359.301 62.9651 360.409 61.9987 360.477 58.0149C360.598 47.7282 359.118 37.5522 357.707 27.4468C356.454 18.5245 355.356 11.7432 353.758 3.92558C353.011 0.274568 350.733 -0.598595 347.411 0.842569C344.43 2.13699 341.347 3.41576 338.66 5.21522C328.936 11.6535 319.419 18.3037 309.788 24.8964C308.587 25.7084 307.601 26.2742 306.31 27.4317C304.759 28.8485 303.55 29.7992 304.615 31.4425C305.61 33.0151 308.236 32.1449 309.475 31.4585C319.952 25.936 341.375 14.2049 342.657 13.8248C340.572 20.4113 338.786 26.5449 336.641 32.6027C321.494 74.7274 303.364 115.55 275.438 152.035C253.334 180.916 228.109 206.895 198.827 229.249C197.107 230.58 195.48 232.065 193.942 233.523C191.827 235.472 191.077 236.833 192.024 237.919C194.097 239.719 195.873 238.736 197.357 238.068C200.338 236.774 203.089 234.864 205.764 233.023C241.285 208.044 269.579 176.689 293.785 141.763C318.631 105.918 334.239 66.4816 346.43 25.7351C346.988 23.5649 348.89 18.3082 349.487 17.4023Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M358.069 22.0457C358.817 33.9186 359.485 45.3154 360.197 56.7003C360.328 58.9712 360.424 60.5735 361.081 63.3818C361.546 65.4729 362.632 69.8844 364.89 68.8725C366.669 67.8533 367.802 66.9167 367.976 62.9361C368.371 52.6563 367.161 42.4445 366.019 32.3052C365.004 23.3528 364.086 16.5446 362.697 8.68732C362.048 5.01776 359.793 4.08436 356.434 5.43671C353.419 6.65145 350.304 7.84785 347.57 9.57525C337.678 15.7528 327.987 22.1477 318.185 28.4821C316.962 29.2619 315.962 29.8013 314.64 30.9241C313.052 32.2992 311.819 33.2174 312.84 34.8884C313.793 36.4869 316.441 35.6868 317.698 35.0336C328.318 29.7915 350.045 18.6339 351.336 18.288C349.077 24.8168 347.129 30.9007 344.823 36.8994C328.562 78.6066 309.354 118.933 280.468 154.663C257.604 182.946 231.697 208.246 201.832 229.814C200.077 231.098 198.411 232.539 196.835 233.956C194.669 235.848 193.884 237.189 194.801 238.3C196.825 240.154 198.627 239.219 200.128 238.59C203.143 237.376 205.943 235.54 208.666 233.771C244.839 209.744 273.956 179.152 299.081 144.882C324.872 109.711 341.522 70.7025 354.792 30.2944C355.407 28.1398 357.448 22.9355 358.069 22.0457Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 160,
    width: 100,
    height: 100,
    rx: 18,
    fill: "#FDB940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8042 190.64C37.6257 189.818 38.5888 189.422 40.8834 189.422H45.2176H56.7471H84.5937H85.6418H86.69C88.6729 189.422 90.0327 190.017 90.6559 191.037C91.7324 191.943 92.3839 193.274 92.0156 195.172L87.6814 211.886C86.69 217.127 85.4152 220.073 87.6248 220.866C92.7522 222.707 93.432 218.062 94.5085 215.625C96.2082 211.801 99.8625 209.138 104.027 208.968C104.197 208.968 104.338 208.968 104.508 208.968C106.406 208.968 107.568 209.365 107.511 209.591L103.828 219.478C102.185 223.869 97.0864 232.962 82.6674 230.611C77.0867 229.704 72.9792 223.784 75.1604 215.115L79.4663 198.515H54.6509H43.2913H39.4387C36.7475 198.515 35.1895 197.382 35.1895 195.399C35.1895 194.294 35.671 191.773 36.8042 190.64Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4082 194.379C99.4082 190.697 102.099 187.75 106.349 187.75C110.116 187.75 112.552 189.875 112.552 193.218C112.552 196.9 109.776 199.847 105.527 199.847C101.759 199.847 99.4082 197.637 99.4082 194.379Z",
    fill: "#333333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_0_1",
    x: -1.10989,
    y: 140.418,
    width: 128.286,
    height: 121.758,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.08791,
    dy: -1.08791
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.63187
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.35165,
    dy: -3.26374
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71978
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -9.79121,
    dy: -6.52747
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26374
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -17.4066,
    dy: -10.8791
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35165
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_0_1",
    result: "effect4_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 160,
    width: 100,
    height: 100,
    rx: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToHome);
export default __webpack_public_path__ + "static/media/AddToHome.90d17a7553d5836cbf15647de58c5a31.svg";
export { ForwardRef as ReactComponent };